
import { CharityProducts } from "@/components/CharityProducts";
import { CharityHeader } from "@/components/charity/CharityHeader";
import { ChurchSponsorForm } from "@/components/charity/ChurchSponsorForm";
import { Navigation } from "@/components/Navigation";
import { Toaster } from "@/components/ui/toaster";
import { useEffect } from "react";
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";
import { useToast } from "@/hooks/use-toast";
import { useSearchParams } from "react-router-dom";

const Give = () => {
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success');
  const { branding } = useChurchBranding();

  // Show success message when redirected from successful checkout
  useEffect(() => {
    if (success === 'true') {
      toast({
        title: "Donation Successful",
        description: "Thank you for your generous donation! Your support helps us continue our mission.",
        duration: 6000,
      });
    }
  }, [success, toast]);
  
  // Ensure the page scrolls to top when mounted
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const getPageClasses = () => {
    return "min-h-screen bg-app-background pb-20 transition-colors duration-300";
  };

  const getSectionClasses = () => {
    return "max-w-2xl mx-auto bg-app-surface/90 backdrop-blur-sm rounded-xl shadow-md p-6 md:p-8 border border-app-border transition-all hover:shadow-lg";
  };

  const getThankYouClasses = () => {
    return "max-w-2xl mx-auto bg-app-surface/80 backdrop-blur-sm rounded-xl p-8 border border-app-border shadow-md transition-all hover:shadow-lg";
  };

  const getTextColor = () => {
    return "text-app-text-primary";
  };

  const getDividerColor = () => {
    return "bg-app-border";
  };

  return (
    <div className={getPageClasses()}>
      <div className="py-8 px-2.5 md:container">
        <CharityHeader />
        
        {/* Re-add the products section to display donation options */}
        <div className="mt-8 mb-12">
          <CharityProducts />
        </div>
        
        {/* Support Grace Awakens Section */}
        <div className="mt-12 mb-16 animate-fade-in" style={{ animationDuration: "1s" }}>
          <h2 className="text-xl md:text-2xl font-semibold text-center mb-6 text-app-text-primary">
            Support Grace Awakens
          </h2>
          <div className={getSectionClasses()}>
            <ChurchSponsorForm />
          </div>
        </div>
        
        {/* Thank You Message at the bottom */}
        <div className="mt-16 mb-32 text-center animate-fade-in" style={{ animationDuration: "1.2s", animationDelay: "0.4s" }}>
          <div className={getThankYouClasses()}>
            <h3 className="text-xl font-semibold font-grace mb-3 text-app-text-primary">
              Thank You for Your Support
            </h3>
            <p className={`${getTextColor()} max-w-xl mx-auto mt-2 text-sm mb-4 transition-colors duration-300`}>
              Your generosity helps us continue our mission and spread faith throughout the community.
            </p>
            <div className={`w-20 h-1 ${getDividerColor()} mx-auto rounded-full transition-colors duration-300`}></div>
          </div>
        </div>
      </div>
      <Navigation />
      <Toaster />
    </div>
  );
}

export default Give;
